import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { api } from '../../api.ts';
import { TopBar } from '../../components/TopBar.tsx';
import { TrustBadges } from '../../components/TrustBadges.tsx';
import { MatchBadge } from '../../components/MatchBadge.tsx';
import { ProLine } from '../../components/ProSummary.tsx';
import { RatingLine } from '../../components/RatingLine.tsx';
import { ReliabilityBadges } from '../../components/ReliabilityBadges.tsx';
import type { ExtraProfile } from '../../types.ts';
import { Avatar } from '../../components/Avatar.tsx';

export function SearchExtras() {
  const { id: missionId } = useParams();
  const [extras, setExtras] = useState<ExtraProfile[]>([]);

  useEffect(() => {
    // Pour une mission précise, le serveur classe les extras par compatibilité.
    api.get<{ extras: ExtraProfile[] }>(`/extras/search${missionId ? `?missionId=${missionId}` : ''}`).then((res) => setExtras(res.extras));
  }, [missionId]);

  return (
    <div className="app-shell">
      <TopBar title="Trouver un extra" back />
      <div className="screen-content">
        <div style={{ fontSize: 12.5, fontWeight: 700, color: 'var(--text-tertiary)' }}>
          {extras.length} extra{extras.length > 1 ? 's' : ''} disponible{extras.length > 1 ? 's' : ''}
        </div>
        {extras.length === 0 && <div className="empty-state">Aucun extra inscrit pour le moment.</div>}
        <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
          {extras.map((e) => (
            <Link
              key={e.id}
              to={missionId ? `/resto/extras/${e.id}?missionId=${missionId}` : `/resto/extras/${e.id}`}
              className="card"
              style={{ textDecoration: 'none', color: 'inherit', display: 'flex', gap: 12 }}
            >
              <Avatar avatar={e.avatar} size={48} label={`${e.first_name} ${e.last_name}`} />
              <div style={{ flex: 1 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <div style={{ fontWeight: 800 }}>{e.first_name} {e.last_name}</div>
                </div>
                <div style={{ marginTop: 4 }}>
                  <RatingLine rating={e.rating} />
                  <span style={{ fontSize: 12.5, color: 'var(--text-tertiary)' }}>{e.missions_completed} missions</span>
                </div>
                <div style={{ marginTop: 6 }}><ProLine pro={e.pro} /></div>
                <div style={{ marginTop: 8, display: 'flex', flexDirection: 'column', gap: 6 }}>
                  {missionId && <MatchBadge match={e.match} perspective="resto" />}
                  <ReliabilityBadges reliability={e.reliability} />
                  <TrustBadges badges={e.badges} />
                </div>
                {e.skills.length > 0 && (
                  <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', marginTop: 8 }}>
                    {e.skills.slice(0, 3).map((s) => (
                      <span key={s} className="badge badge-neutral">{s}</span>
                    ))}
                  </div>
                )}
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
